export const EMAIL_DEFAULT_GREETING = 'Hello'
export const CONFIRMATION_EMAIL_DEFAULT_MESSAGE =
  "Thank you for accepting the invitation! We are thrilled to have you join us on this special occasion, and we can't wait to see you soon."

export const REGRET_EMAIL_DEFAULT_MESSAGE =
  'Thank you! We sincerely appreciate your honesty and understanding in letting us know that you won’t be able to attend.'
export const GUEST_FULL_NAME = '(Guest name)'
